import { type LigneMouvement, Nature, Section } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import FctvaPanel from '../panel/FctvaPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import MandatEmisApresPaiementPanel from '../panel/InformationsRattachement/MandatEmisApresPaiementPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import BaseProfilRattachement from './Base/BaseProfilRattachement';

class ProfilEcritureFonctEmiseApresPaiementDepense extends BaseProfilRattachement {
	constructor(anneeExercice: number) {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.FONCT_EMISE_APRES_PAIEMENT;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.FONCTIONNEMENT;
		this.typePiece = TYPE_PIECE.DEPENSE.EMIS_APRES_PAIE;
		this.imputation.section = Section.FONCTIONNEMENT;
		this.imputation.nature = Nature.REEL;
		this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE];
		this.defaultModeReglement = MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE;
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.MANDAT.PAIEMENT.CODE;
		this.exerRattachement = anneeExercice?.toString();
		this.idLigneOriginePes = 0;
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new FctvaPanel(),
			new InformationsChorusProPanel(),
			new MandatEmisApresPaiementPanel(true),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
			new TravauxEnRegiePanel(),
			// TODO : add "Nomenclature achat" optional panel
		];
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementAnterieurOuEgal(ligne),
			...this.checkIdLigneOriginePesNul(ligne),
		];
	}
}

export default ProfilEcritureFonctEmiseApresPaiementDepense;
